import { memo } from 'react';
import { useLocation } from 'wouter';

import Icon from 'components/Icon/Icon';
import { useLanguage, useSessionLocation } from 'store';

import styles from './BackButton.module.scss';

const BackButton = memo(() => {
  const [, navigate] = useLocation();
  const [{ basePath }] = useLanguage();
  const [{ isFirstLocation }] = useSessionLocation();

  const onClickHandler = () =>
    isFirstLocation ? navigate(`~${basePath}/`) : history.back();

  return (
    <button
      type="button"
      className={styles['back-button']}
      onClick={onClickHandler}
    >
      <Icon className={styles.icon} name="arrow-left" height={32} width={32} />
    </button>
  );
});

export default BackButton;
